var map = {
	"./mts-main-products-boards.mp4": 2420,
	"./mts-main-products-chats.mp4": 2421,
	"./mts-main-products-comdi.mp4": 2422,
	"./mts-main-products-courses.mp4": 2423,
	"./mts-main-products-equipment.mp4": 2424,
	"./mts-main-products-forms.mp4": 2425,
	"./mts-main-products-meetings.mp4": 2426,
	"./mts-main-products-webinars.mp4": 2427,
	"./mts-products-chats-account-management.mp4": 2428,
	"./mts-products-chats-adding-employees.mp4": 2429,
	"./mts-products-chats-ai-assistant.mp4": 2430,
	"./mts-products-chats-appointment-moderators.mp4": 2431,
	"./mts-products-chats-chats-and-channels.mp4": 2432,
	"./mts-products-chats-distribution-groups.mp4": 2433,
	"./mts-products-chats-favorite-features.mp4": 2434,
	"./mts-products-chats-in-platform.mp4": 2240,
	"./mts-products-chats-one-click-call.mp4": 2435,
	"./mts-products-chats-promo-mobile.mp4": 2239,
	"./mts-products-chats-promo.mp4": 2340,
	"./mts-products-comdi.mp4": 2234,
	"./tab-intelligence-video.mp4": 2241,
	"./webinar-meetings.mp4": 2436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2182;